function getPageOffset(elem: HTMLElement | null | undefined) {
  let topOffset = elem?.getBoundingClientRect().top ?? 0;

  while (elem !== document.documentElement) {
    elem = elem?.parentElement;
    topOffset += elem?.scrollTop ?? 0;
  }
  return topOffset;
}

export default getPageOffset;
